import { render, staticRenderFns } from "./CheckAnswerType.vue?vue&type=template&id=27d673bf&"
import script from "./CheckAnswerType.vue?vue&type=script&lang=js&"
export * from "./CheckAnswerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports